import { render, staticRenderFns } from "./WebProjects.vue?vue&type=template&id=6bd894cb"
import script from "./WebProjects.vue?vue&type=script&lang=js"
export * from "./WebProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports